import * as events from '@/events'
import { addCloseButtonToAllAirportsDropdownLists } from '@/modules/customizations/airport'

const $ = require('jquery')
const moment = require('moment')

const ajaxLoader = require('./ajaxLoader')
const { URL_API, SELECTOR } = require('./api')
const FORMS = require('./forms')
const { globals, Loader } = require('./globals')
const Overlay = require('./overlay')

// =========================================================================
// Form filters for offers
// =========================================================================

function filtersAllData (expression, valueFromFilter, resultElement, isCallAjax) {
  let datasAttr = null
  let dataHotelSlug = null
  let dataOfferCode = null
  let dataObjectCode = null
  let pageFrom = null

  datasAttr = $('#all-offers')
  if (datasAttr.length > 0) {
    dataHotelSlug = datasAttr.attr('data-hotelslug')
    dataOfferCode = datasAttr.attr('data-offercode')
    dataObjectCode = datasAttr.attr('data-objectcode')
  } else {
    datasAttr = $('#modal-offers .table-offers')
    dataHotelSlug = datasAttr.attr('data-hotelslug')
    dataOfferCode = datasAttr.attr('data-offercode')
    dataObjectCode = datasAttr.attr('data-objectcode')
  }
  datasAttr = resultElement

  if (expression !== 'PageNumber') {
    datasAttr.find('#searchPageFrom').val('0')
  }

  pageFrom = datasAttr.find('#searchPageFrom').val()

  const getDurationType = () => {
    const durationVal = valueFromFilter.Duration
    if (durationVal !== null && typeof durationVal !== 'undefined') {
      if (durationVal.indexOf(':') !== -1) {
        return 'DurationInterval'
      } else {
        return '&DurationDays='
      }
    } else {
      return 'DurationInterval'
    }
  }
        
  const tableForm = datasAttr.find('.table-offers > .row > div')
  const elemForm = datasAttr.find('#table-offers-content')

  const urlJsonGetOffers = function(otherParams, isModal) {
    if (typeof otherParams == 'undefined') {
      otherParams = ''
    }

    const params = {
      hotelSlug: dataHotelSlug,
      offercode: dataOfferCode,
      objectcode: dataObjectCode,
      pageFrom,
      [getDurationType()]: valueFromFilter.Duration,
      Price: valueFromFilter.PricePerson,
      SortBy: valueFromFilter.SortBy,
      SortAsc: valueFromFilter.SortAsc,
    }

    const knownParams = Object.keys(params)
      .filter(param => params[param])
      .map(param => `${param}=${params[param]}`)
      .join('&')
    const result = `${URL_API.HotelAllOffersAsJson}?${knownParams}&${getPassedFilterData(isModal)}&${otherParams}`
    log.debug('urlJsonGetOffers / result', result)

    return result
  }

  const getPassedFilterData = function(isModal) {
    const params = {
      Adults: valueFromFilter.Adults,
      Children: valueFromFilter.Children,
      Dates: valueFromFilter.Dates,
      airports: valueFromFilter.Airports,
      Room: valueFromFilter.Room,
      BoardStandards: valueFromFilter.Food,
    }
    let url = Object.keys(params)
      .filter(param => params[param])
      .map(param => `${param}=${params[param]}`)
      .join('&')

    let inputs = null
    if (isModal) {
      inputs = $('.form-filters-popup .dropdown-menu__inner .form-group .form-control')
    } else {
      inputs = $('.offer-search-simple .dropdown-menu__inner .form-group .form-control')
    }

    if (inputs.length) {
      for (let i = 1; i <= valueFromFilter.Children; i++) {
        const rawInputValue = inputs[i - 1].value
        let inputValue = null
        if (rawInputValue) {
          inputValue = moment(rawInputValue, 'DD.MM.YYYY').format('YYYYMMDD')
        }

        if (inputValue) {
          url += `&Child${i}=${inputValue}`
        }
      }
    }

    return url
  }

  const updateDataAttributes = function() {
    dataOfferCode = datasAttr.attr('data-offercode')
  }

  let isModal = false
  if (resultElement) {
    if ((resultElement.selector && resultElement.selector == '#modal-offers') || resultElement[0].id === 'modal-offers') {
      isModal = true
    }
  }

  if (isModal) {
    if (!$._data($('.form-filters-popup .custom-select-people')[0], 'events')) {
      $('.form-filters-popup .custom-select-people').on('hide.bs.dropdown', function() {
        updateDataAttributes()
        getOffersTableHotelData()
      })
    }
  }
  else {
    if (!$._data($('.offer-search-simple .custom-select-people')[0], 'events')) {
      $('.offer-search-simple .custom-select-people').on('hide.bs.dropdown', function() {
        updateDataAttributes()
        getOffersTableHotelData()
      })
    }
  }

  const getOffersTableHotelData = function() {
    ajaxLoader.abort()
    ajaxLoader.init({
      devTest: true,
      url: urlJsonGetOffers(undefined, isModal),
      method: 'GET',
      templateName: 'OffersTableHotel',
      passedFilterData: getPassedFilterData(isModal),
      type: 'offersTable',
      placeholder: elemForm,
      clearPlaceholder: (pageFrom === '0'),
      beforeSendRequest () {
        Overlay.addTo(tableForm, 'white')
        tableForm.prepend(Loader('small', 'blue'))
      },
      callback () {
        $('.offer-content__sidebar').on('sticky_kit:bottom', function() {
          $(this).css('right', 0)
        })
        $(document.body).trigger('sticky_kit:recalc')
        events.formsListUpdated()
      },
      afterSuccess (results) {
        events.offersLoaded({ offers: results })

        const countOffersToLoad = results.OffersToLoad
        const showMoreOffersTable = datasAttr.find('.load-more-offers')

        showMoreOffersTable
          .find('span > span')
          .text(`(${countOffersToLoad})`)

        if (countOffersToLoad != 0) {
          showMoreOffersTable.show()
        } else {
          showMoreOffersTable.hide()
        }

        Overlay.removeFrom(tableForm)
        $('.loader__inner').remove()
      },
    })
  }

  if (isCallAjax) {
    getOffersTableHotelData()
  }
}

function init () {
  const elementsInitDropdowns = [
    '.custom-select-price-person .section-title',
    '.custom-select-food .section-title',
    '.custom-select-room .section-title',
    '.custom-select-people .section-title',
    '.custom-select-duration .section-title',
  ]
  const elemsForBuildDropdowns = [
    '.custom-select-price-person > .form-group',
    '.custom-select-people > .form-group',
    '.custom-select-food > .form-group',
    '.custom-select-room > .form-group',
    '.custom-select-duration > .form-group',
  ]

  const getUrlParameter = function(sParam) {
    const sPageURL = decodeURIComponent(window.location.search.substring(1))
    const sURLVariables = sPageURL.split('&')
    let sParameterName = null
    let i = null

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=')

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1]
      }
    }
    return null
  }

  SELECTOR.FORM_FILTERS_OFFERS = $(document).find('.form-filters-offers')

  let attachHandler = true
  let resultElement = $('#all-offers')
  let mainControl = SELECTOR.FORM_FILTERS_OFFERS
  let $modalTableOffers = $(document).find('#modal-offers .table-offers')
  if ($modalTableOffers.exists()) {
    attachHandler = false
    resultElement = $(document).find('#modal-offers')
    mainControl = $(document).find('.form-filters-offers.form-filters-popup')
  }

  const csPeopleParent = mainControl.find('.custom-select-people .form-group label + div')
  const csChildrenParent = mainControl.find('.custom-select-people .form-group').slice(2)

  //Update initial settings
  let adults = getUrlParameter('Adults')
  if (!adults) {
    adults = '2'
  }
  csPeopleParent.eq(0).find('input').val(adults)

  let children = getUrlParameter('Children')
  if (!children) {
    children = '0'
  }
  csPeopleParent.eq(1).find('input').val(children)

  const initializeChildren = function(_index, _value) {
    let child = moment(_value, 'YYYYMMDD')
    child = moment(child).format('DD.MM.YYYY')
    csChildrenParent.eq(_index).find('input.form-control').val(child)
  }

  const csAdultInput = csPeopleParent.eq(0).find('input').val()
  const csChildrenInput = csPeopleParent.eq(1).find('input').val()

  for (let i = 0; i < csChildrenInput; i++) {
    initializeChildren(i, getUrlParameter(`Child${i + 1}`))
  }

  const objQueryFilters = {
    Airports: null,
    Dates: null,
    Duration: null,
    Adults: csAdultInput,
    Children: csChildrenInput,
    Room: null,
    Food: null,
    PricePerson: null,
    SortBy: 6,
    SortAsc: 1,
  }

  resultElement = $('#all-offers')
  $modalTableOffers = $(document).find('#modal-offers .table-offers')
  if ($modalTableOffers.exists()) {
    resultElement = $(document).find('#modal-offers')
  }

  if (attachHandler) {
    globals.updateValueCallback = function(sourceControl, offerCode) {
      const resultElement = $('#all-offers')
      resultElement.attr('data-offercode', offerCode)

      const sourcePeopleParent = sourceControl.find('.custom-select-people .form-group label + div')

      function updateChildData (index) {
        const value = getUrlParameter(`Child${index + 1}`)

        if (value !== undefined) {
          let child = moment(value, 'YYYYMMDD')
          child = moment(child).format('DD.MM.YYYY')
          csChildrenParent.eq(index).find('input.form-control').val(child)
        }
      }

      const sourceAdults = sourcePeopleParent.eq(0).find('input').val()
      const sourceChildren = sourcePeopleParent.eq(1).find('input').val()
      csPeopleParent.eq(0).find('input').val(sourceAdults)
      csPeopleParent.eq(1).find('input').val(sourceChildren)

      for (let i = 0; i < sourceChildren; i++) {
        updateChildData(i)
      }

      const objCounter = {
        Adults: sourceAdults,
        Children: sourceChildren,
      }
      FORMS.customSelect.people.changeAmount(SELECTOR.FORM_FILTERS_OFFERS, false, null, null, objCounter)

      objQueryFilters.Adults = sourceAdults
      objQueryFilters.Children = sourceChildren

      filtersAllData('', objQueryFilters, resultElement, true)
    }
  }

  const $csTitle = $('[class*=" custom-select-"] .section-title')

  // -----------------------------------------------------------------------
  // Build fake labels for custom fields
  // -----------------------------------------------------------------------
  const elementsFakeLabels = SELECTOR.FORM_FILTERS_OFFERS.find($csTitle)

  FORMS.helpers.csFakeLabel(elementsFakeLabels)
  // -----------------------------------------------------------------------
  // Build dropdowns for custom fields
  // -----------------------------------------------------------------------
  for (let i = 0; i < elemsForBuildDropdowns.length; i++) {
    FORMS.helpers.csDropdownBuild(
      SELECTOR.FORM_FILTERS_OFFERS.find(elemsForBuildDropdowns[i])
    )
  }

  for (let i = 0; i < elementsInitDropdowns.length; i++) {
    FORMS.helpers.csDropdownRun(
      SELECTOR.FORM_FILTERS_OFFERS.find(elementsInitDropdowns[i])
    )
  }

  const closeButton = '<div class="custom-select-date__close">×</div>'
  const datepickerError = $('<div class="custom-select-date__title">Brak ofert spełniajacych kryteria</div>')
  const datepickerErrorMessage = $('<div class="custom-select-date__error-msg" />')
  const errorContainer = $('<div class="custom-select-date__error" />')

  const errorContent = [
    datepickerError,
    datepickerErrorMessage,
    closeButton,
  ]

  if ($('.custom-select-date__container.offers').length === 0) {
    errorContainer.insertAfter('.form-filters-offers .custom-select-date .form-group:eq(2)')
    errorContainer.append(errorContent)
  }

  // =====================================================================
  // Custom select date
  // =====================================================================
  const updateValues = main => {
    log.debug('formFilterOffers.js / custom select date / updateValues(main:', main, ')')

    const _d1ToQueryString = moment(main.data.selectedStart, 'YYYY-MM-DD').format('YYYYMMDD')
    const _d2ToQueryString = moment(main.data.selectedEnd, 'YYYY-MM-DD').format('YYYYMMDD')

    objQueryFilters.Dates = `${_d1ToQueryString}:${_d2ToQueryString}`
    if (main.data.range) {
      objQueryFilters.Duration = main.data.range
    }

    if (_d1ToQueryString != _d2ToQueryString) {
      const element = main.closest('aside') ? $(main.closest('aside')) : $(main.closest('#all-offers'))
      if (element.length > 0)
        filtersAllData('Dates', objQueryFilters, element, true)
    }
  }

  // Loop through all date selectors in the document and initialize the initializer
  // I know this sounds stuppid but the flow is as follows:
  //   1. Data is loaded from the document
  //   2. In calendar.js the calendar gets initialized when all data from other places
  //      is fully available
  //   3. This allows us to tap into the "change" event on controls and handle the data change
  //   4. Then when a user changes the datas then data needs to be updated
  //   5. New calendar can be loaded as part of an ajax call (_in an overlay!!!_)
  //   6. In calendar.js the calendar gets initialized when all data from other places
  //      is fully available
  //   7. This allows us to tap into the "change" event on controls and handle the data change
  //
  // ALL THIS CRAZY LOGIC WILL GO AWAY WHEN THE SEARCH WILL FINALLY BE DONE IN VUE!!!
  document.querySelectorAll('.custom-select-date').forEach(dateSelector => {
    if (dateSelector.dataset.formFiltersOffersInitialized) {
      return
    }
    dateSelector.dataset.formFiltersOffersInitialized = true

    // When the calendar is initialized the form fires grecos:calendar:initialized event
    // notifying that the calendar is fully initialized. In this case, because the closure
    // in this case does matter, we add the change event handler
    const form = dateSelector.closest('form')
    form.addEventListener('grecos:calendar:initialized', (e, { main } = e.detail) => {
      log.debug('formFilterOffers.js / custom select date main:', main)
      if (main) {
        main.addEventListener('change', e => {
          if (e.target == main)
            updateValues(main)
        })
      }
    })
  })

  const pageNumberElement = resultElement.find('#searchPageFrom')
  resultElement.find('.load-more-offers').on('click', function() {
    const pageFrom = pageNumberElement.val()
    pageNumberElement.val((parseInt(pageFrom) + 1).toString())
    filtersAllData('PageNumber', objQueryFilters, resultElement, true)
  })

  // -----------------------------------------------------------------------
  // Custom select airport
  // -----------------------------------------------------------------------
  const csAirportFiltersOffers = $('.form-filters-offers .custom-select-airport .section-title')
  csAirportFiltersOffers.addClass('section-label')

  SELECTOR.FORM_FILTERS_OFFERS.find('.custom-select-airport select')
    .selectpicker({
      'noneSelectedText': 'Wylot z...',
      'selectedTextFormat': 'count > 2',
      countSelectedText (num) {
        if (num > 1) {
          return 'wybrano {0} lotniska'
        } else {
          return ''
        }
      },
      'iconBase': 'custom-checkbox',
      'tickIcon': 'custom-checkbox-checked',
    })
    .on('changed.bs.select', function(e) {
      const selected = $(e.currentTarget).val()

      if (selected !== null) {
        csAirportFiltersOffers.fadeIn()
      } else {
        $(this).selectpicker('noneSelectedText', 'Wylot z...')
        $(this).selectpicker('refresh')

        csAirportFiltersOffers.fadeOut()
      }
      objQueryFilters.Airports = selected

      filtersAllData('Airports', objQueryFilters, resultElement, true)
    })

  addCloseButtonToAllAirportsDropdownLists()

  // -----------------------------------------------------------------------
  // Custom select duration
  // -----------------------------------------------------------------------
  FORMS.customSelect.duration(
    SELECTOR.FORM_FILTERS_OFFERS,
    false,
    function(inputValues) {
      objQueryFilters.Duration = inputValues
      filtersAllData('Duration', objQueryFilters, resultElement, true)
    }
  )
  SELECTOR.FORM_FILTERS_OFFERS.find('.custom-select-duration .dropdown-menu').perfectScrollbar()

  // -----------------------------------------------------------------------
  // Custom select people
  // -----------------------------------------------------------------------
  FORMS.customSelect.people.init(
    SELECTOR.FORM_FILTERS_OFFERS,
    false,
    function(name, value) {
      const _name = name.toString()

      if (_name == 'Adults') {
        objQueryFilters.Adults = value

        filtersAllData('Adults', objQueryFilters, resultElement, false)
      } else if (_name == 'Children') {
        objQueryFilters.Children = value

        filtersAllData('Children', objQueryFilters, resultElement, false)
      }
    }
  )

  // -----------------------------------------------------------------------
  // Custom select price person
  // -----------------------------------------------------------------------
  FORMS.customSelect.pricePerson({
    parentSel: SELECTOR.FORM_FILTERS_OFFERS,
    callback (inputValues) {
      objQueryFilters.PricePerson = inputValues

      filtersAllData('PricePerson', objQueryFilters, resultElement, true)
    },
  })

  // -----------------------------------------------------------------------
  // Custom select rooms
  // -----------------------------------------------------------------------
  FORMS.customSelect.room(SELECTOR.FORM_FILTERS_OFFERS, function(inputValue) {
    objQueryFilters.Room = inputValue

    filtersAllData('Room', objQueryFilters, resultElement, true)
  })

  // -----------------------------------------------------------------------
  // Custom select foods
  // -----------------------------------------------------------------------
  FORMS.customSelect.food(SELECTOR.FORM_FILTERS_OFFERS, function(inputValue) {
    objQueryFilters.Food = inputValue

    filtersAllData('Food', objQueryFilters, resultElement, true)
  })

  const extendableOfferList = resultElement.find('#table-offers-content')
  if (extendableOfferList.length) {
    filtersAllData('PageNumber', objQueryFilters, resultElement, true)
  }

  // Disable closing popups on click except for close button
  $('div[class*=" custom-select-"] .dropdown-menu').click(e => {
    if (!e.target.classList.contains('close'))
      e.stopPropagation()
  })
}

module.exports = {
  init,
}




// WEBPACK FOOTER //
// ./src/modules/formFiltersOffers.js